
// Suppress Locize promo console message
const originalInfo = console.info;
console.info = function (...args) {
  if (
    typeof args[0] === 'string' &&
    args[0].includes('🌐 i18next is made possible by our own product, Locize')
  ) {
    return;
  }
  originalInfo.apply(console, args);
};

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import landing from '@/data/locales/en/landing.json';
import features from '@/data/locales/en/features.json';
import extra from '@/data/locales/en/extra.json';
import talkshow from '@/data/locales/en/talkshow.json';

export const initI18n = () => {
  if (i18n.isInitialized) return i18n;
  
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        en: { 
          translation: {
            ...landing,
            ...features,
            ...extra,
            talkshow
          } 
        },
      },
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false,
      },
    });
    
  return i18n;
};

export default i18n;
